import React, { useState } from 'react';
import {View} from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import { useNavigation } from '@react-navigation/native';

import styles from '../../style/scanpack';
import {useDispatch, useSelector} from 'react-redux';
import PassButton from '../../commons/passButton';
import ScanAllButton from '../../commons/scanAllButton';
import BarcodeInput from './BarcodeInput';
import {
  handleBarcodeInput,
  handlePassButton,
  setBarcodeInput,
  processPickCompleteBarcode,
  handleScanAllCart
} from '../../actions/ScanToCartScanningActions';
import { getProductRemainingCount } from './utils/scanProgressUtils';
import { useCameraScanner } from '../../helpers/useCameraScanner';
import CamScanner from '../camScanning/CamScanner';

const ScanBarcodeSection = ({windowWidth}) => {
  const {currentOrder, nextPickItem, isCartView, pickComplete, isMultiToteModalOpen} = useSelector(state => ({
    currentOrder: state.scanToCartScanning.currentOrder,
    isCartView: state.scanToCart.isCartView,
    nextPickItem: state.scanToCart.nextPickItem,
    pickComplete: state.scanToCartScanning.cartScanComplete,
    isMultiToteModalOpen: state.scanToCartScanning.prompt?.isVisible && state.scanToCartScanning.prompt?.type === 'multiToteVerification'
  }));
  const barcodeValue = useSelector(
    state => state.scanToCartScanning.barcodeValue
  );
  const toteAssignments = useSelector(state => state.scanToCart.toteAssignments);
  const scanAllOption = useSelector(
    state => state.user?.bothSettings?.data?.data?.scanpack_setting?.scan_all_option || false
  );
  const typeScanState = useSelector(state => state.scanToCartScanning.typeScanState);
  const dispatch = useDispatch();

  const navigation = useNavigation();
  const { showCameraScanner, camScannerEnabled, openCamera, closeCamera } = useCameraScanner('scanToCart', { navigation });
  const [isCamLoading, setIsCamLoading] = useState(false);

  const handleButtonPress = async () => {
    if (barcodeValue === '') {
      dispatch(handlePassButton());
      return;
    }
    dispatch(handleBarcodeInput());
  };

  const currentItem = nextPickItem?.item;
  const passButtonDisabled =
    isCartView || (currentItem?.qty_remaining === 0 && currentItem?.skipped_qty === 0);
  const scanAllCount = getProductRemainingCount(currentItem?.product_id, toteAssignments);
  const scanAllItemTotal = (currentItem?.scanned_qty || 0) + (currentItem?.qty_remaining || 0);
  const showScanAll =
    scanAllOption &&
    !!currentItem?.sku &&
    typeScanState === currentItem.sku &&
    scanAllItemTotal >= 3 &&
    scanAllCount > 0;

  const handleCameraScan = (scannedValue) => {
    if (scannedValue) {
      dispatch(setBarcodeInput(scannedValue));
      setTimeout(() => {
        if (pickComplete) {
          dispatch(processPickCompleteBarcode(scannedValue, setIsCamLoading));
        } else {
          dispatch(handleBarcodeInput());
        }
      }, 100);
    }
  };

  return (
    <LinearGradient
      start={{x: 0, y: 1}}
      end={{x: 0, y: 0}}
      colors={['#142130', '#304454']}
      style={styles.scanBarcodeGradientDesktop}>
      <View style={{flexDirection: 'row'}}>
        <View style={styles.scanBarcodeContainer}>
          <LinearGradient
            start={{x: 0, y: 1}}
            end={{x: 0, y: 0}}
            colors={['#6384ff', '#1329ff', '#35096c']}
            style={styles.scanBarcodeSubGradient}
          />
        </View>

        <View
          dataSet={{componentName: 'barcodeScan'}}
          style={styles.scanBarCodeInputContainer}>
          <BarcodeInput
            windowWidth={windowWidth}
            camScannerEnabled={camScannerEnabled && !isMultiToteModalOpen}
            onCameraOpen={openCamera}
          />
        </View>

        {showScanAll ? (
          <ScanAllButton
            orderItem={nextPickItem?.item || {}}
            order={currentOrder}
            onPress={() => dispatch(handleScanAllCart())}
            windowWidth={windowWidth}
            totalCount={scanAllCount}
          />
        ) : (
          <PassButton
            orderItem={nextPickItem?.item || {}}
            order={currentOrder}
            onPress={handleButtonPress}
            onLongPress={() => {}}
            windowWidth={windowWidth}
            disAblePassButton={passButtonDisabled}
          />
        )}
      </View>

      {camScannerEnabled && showCameraScanner && !isMultiToteModalOpen && (
        <View style={{ width: windowWidth > 900 ? '60%' : windowWidth > 600 ? '80%' : '100%', alignSelf: 'center', marginTop: 10 }}>
          <CamScanner
            inline={true}
            onScan={handleCameraScan}
            onClose={closeCamera}
          />
        </View>
      )}
    </LinearGradient>
  );
};

export default ScanBarcodeSection;
